// // Admin_Report_Model_For_Requested_Data.jsx
// import React, { useState, useEffect } from 'react';
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   Box,
//   Typography,
//   Alert,
//   CircularProgress,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Chip,
//   IconButton,
//   Tooltip,
//   Pagination,
//   Grid,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   TextField,
//   InputAdornment,
//   Stack,
// } from '@mui/material';
// import CloseIcon from '@mui/icons-material/Close';
// import DescriptionIcon from '@mui/icons-material/Description';
// import RefreshIcon from '@mui/icons-material/Refresh';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import PersonIcon from '@mui/icons-material/Person';
// import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
// import { useDispatch, useSelector } from 'react-redux';
// import { GetAll_Sales_Request_Data_Limit_Action } from '../../Redux/Actions/UsersAction';
// import { Notify } from '../../Utility/Notify';

// export const Admin_Report_Model_For_Requested_Data = ({ open, onClose }) => {
//   const dispatch = useDispatch();
  
//   // History states
//   const [page, setPage] = useState(1);
//   const [limit, setLimit] = useState(10);
//   const [statusFilter, setStatusFilter] = useState('');
//   const [fromDate, setFromDate] = useState('');
//   const [toDate, setToDate] = useState('');
//   const [searchUserId, setSearchUserId] = useState('');
//   const [searchSalesId, setSearchSalesId] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [selectedRequest, setSelectedRequest] = useState(null);
//   const [detailsDialogOpen, setDetailsDialogOpen] = useState(false);

//   // Redux state
//   const resrequesthistory = useSelector(state => state.Allusers?.GetAll_SalesRequestData);
//   const resusersAuth = useSelector(state => state.AuthRoot?.Signup);
  
//   // جلب المستخدمين للـ Select - مع فلتر الـ role
//   const usersarray = (Array.isArray(resusersAuth?.data) ? resusersAuth.data : [])
//     .filter(user => {
//       // فلتر الأسماء المستثناة
//       const excludedNames = ["Default", "Default M", "Default T", "Default S", "Developer", "Dev"];
//       if (excludedNames.includes(user?.name)) return false;
      
//       // فلتر الـ role (Sales, Team Leader, Manager فقط)
//       const allowedRoles = ["Sales", "Team Leader", "Manager"];
//       if (!allowedRoles.includes(user?.role)) return false;
      
//       return true;
//     });
  
//   // استخراج البيانات من الـ response حسب الهيكل بتاعك
//   const historyData = resrequesthistory?.data?.data || resrequesthistory?.data || [];
//   const paginationData = resrequesthistory?.pagination || null;
  
//   // استخراج قيم pagination
//   const currentPage = paginationData?.currentPage || 1;
//   const totalPages = paginationData?.totalPages || 1;
//   const totalItems = paginationData?.totalItems || 0;
//   const itemsPerPage = paginationData?.itemsPerPage || limit;

//   // Fetch history when dialog opens or filters change
//   useEffect(() => {
//     if (open) {
//       fetchHistory();
//     }
//   }, [open, page, limit, statusFilter, fromDate, toDate, searchUserId, searchSalesId]);

//   const fetchHistory = async () => {
//     setLoading(true);
//     try {
//       const queryParams = new URLSearchParams({
//         page: page,
//         limit: limit,
//         sortBy: 'createdAt',
//         sortOrder: 'desc',
//         populate: 'true'
//       });
      
//       if (statusFilter) queryParams.append('status', statusFilter);
//       if (fromDate) queryParams.append('fromDate', fromDate);
//       if (toDate) queryParams.append('toDate', toDate);
//       if (searchUserId) queryParams.append('userId', searchUserId);
//       if (searchSalesId) queryParams.append('salesId', searchSalesId);
      
//       const result = await dispatch(GetAll_Sales_Request_Data_Limit_Action(queryParams.toString()));
//       console.log('API Response:', result);
      
//     } catch (error) {
//       console.error('Error fetching admin history:', error);
//       Notify('error', 'Failed to load request history', '');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleResetFilters = () => {
//     setStatusFilter('');
//     setFromDate('');
//     setToDate('');
//     setSearchUserId('');
//     setSearchSalesId('');
//     setPage(1);
//   };

//   const handlePageChange = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleLimitChange = (event) => {
//     setLimit(event.target.value);
//     setPage(1);
//   };

//   const getStatusColor = (status) => {
//     switch(status) {
//       case 'completed': return 'success';
//       case 'pending': return 'warning';
//       case 'failed': return 'error';
//       case 'partial': return 'info';
//       default: return 'default';
//     }
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return '-';
//     return new Date(dateString).toLocaleString('en-GB', {
//       day: '2-digit',
//       month: '2-digit',
//       year: 'numeric',
//       hour: '2-digit',
//       minute: '2-digit'
//     });
//   };

//   // حساب نطاق العناصر المعروضة
//   const startItem = (currentPage - 1) * limit + 1;
//   const endItem = Math.min(currentPage * limit, totalItems);

//   return (
//     <>
//       <Dialog 
//         open={open} 
//         onClose={onClose}
//         maxWidth="xl"
//         fullWidth
//         PaperProps={{
//           sx: {
//             borderRadius: 2,
//             minHeight: '80vh',
//             maxHeight: '90vh'
//           }
//         }}
//       >
//         <DialogTitle sx={{ 
//           display: 'flex', 
//           justifyContent: 'space-between', 
//           alignItems: 'center',
//           borderBottom: '1px solid #e0e0e0',
//           pb: 2,
//           bgcolor: '#f5f5f5'
//         }}>
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//             <DescriptionIcon color="primary" />
//             <Typography variant="h6" component="span">
//               Admin Report - Requested Data History
//             </Typography>
//           </Box>
//           <Button
//             variant="text"
//             onClick={onClose}
//             sx={{ minWidth: 'auto', p: 0.5 }}
//           >
//             <CloseIcon />
//           </Button>
//         </DialogTitle>

//         {/* Filters */}
//         <Box sx={{ p: 3, pb: 0 }}>
//           <Grid container spacing={2} alignItems="center">
//             <Grid item xs={12} sm={2}>
//               <FormControl fullWidth size="small">
//                 <InputLabel>Status</InputLabel>
//                 <Select
//                   value={statusFilter}
//                   label="Status"
//                   onChange={(e) => setStatusFilter(e.target.value)}
//                 >
//                   <MenuItem value="">All</MenuItem>
//                   <MenuItem value="completed">Completed</MenuItem>
//                   <MenuItem value="pending">Pending</MenuItem>
//                   <MenuItem value="failed">Failed</MenuItem>
//                   <MenuItem value="partial">Partial</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
            
//             {/* User Filter - Select with filtered users */}
//             <Grid item xs={12} sm={2}>
//               <FormControl fullWidth size="small">
//                 <InputLabel>User</InputLabel>
//                 <Select
//                   value={searchUserId}
//                   label="User"
//                   onChange={(e) => setSearchUserId(e.target.value)}
//                 >
//                   <MenuItem value="">All Users</MenuItem>
//                   {usersarray.map((user) => (
//                     <MenuItem key={user._id} value={user._id}>
//                       {user.name} - {user.role}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>

          
//             <Grid item xs={12} sm={2}>
//               <TextField
//                 fullWidth
//                 size="small"
//                 label="From Date"
//                 type="date"
//                 value={fromDate}
//                 onChange={(e) => setFromDate(e.target.value)}
//                 InputLabelProps={{ shrink: true }}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <CalendarTodayIcon fontSize="small" />
//                     </InputAdornment>
//                   ),
//                 }}
//               />
//             </Grid>
//             <Grid item xs={12} sm={2}>
//               <TextField
//                 fullWidth
//                 size="small"
//                 label="To Date"
//                 type="date"
//                 value={toDate}
//                 onChange={(e) => setToDate(e.target.value)}
//                 InputLabelProps={{ shrink: true }}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <CalendarTodayIcon fontSize="small" />
//                     </InputAdornment>
//                   ),
//                 }}
//               />
//             </Grid>
//             <Grid item xs={12} sm={2}>
//               <Button
//                 fullWidth
//                 variant="outlined"
//                 onClick={handleResetFilters}
//                 startIcon={<RefreshIcon />}
//               >
//                 Reset Filters
//               </Button>
//             </Grid>
//           </Grid>
//         </Box>

//         {/* Table */}
//         <DialogContent>
//           {loading ? (
//             <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
//               <CircularProgress />
//             </Box>
//           ) : historyData && historyData.length > 0 ? (
//             <>
//               <TableContainer component={Paper} sx={{ maxHeight: '55vh' }}>
//                 <Table stickyHeader size="small">
//                   <TableHead>
//                     <TableRow>
//                       <TableCell>Date</TableCell>
//                       <TableCell>User Info</TableCell>
//                       <TableCell>Sales Info</TableCell>
//                       <TableCell align="center">Requested</TableCell>
//                       <TableCell align="center">Transferred</TableCell>
//                       <TableCell>Status</TableCell>
//                       <TableCell>Notes</TableCell>
//                       <TableCell align="center">Actions</TableCell>
//                     </TableRow>
//                   </TableHead>
//                   <TableBody>
//                     {historyData.map((request) => (
//                       <TableRow key={request._id} hover>
//                         <TableCell>{formatDate(request.createdAt)}</TableCell>
//                         <TableCell>
//                           <Box>
//                             <Typography variant="body2" fontWeight="bold">
//                               {request.userid?.name || request.userid?._id?.slice(-8) || '-'}
//                             </Typography>
//                             <Typography variant="caption" color="text.secondary">
//                               {request.userid?.email || '-'}
//                             </Typography>
//                             <Typography variant="caption" display="block" color="primary">
//                               Role: {request.userid?.role || '-'}
//                             </Typography>
//                           </Box>
//                         </TableCell>
//                         <TableCell>
//                           <Box>
//                             <Typography variant="body2">
//                               {request.salesid?.name || request.salesid?._id?.slice(-8) || '-'}
//                             </Typography>
//                             <Typography variant="caption" color="text.secondary">
//                               {request.salesid?.userlog?.email || '-'}
//                             </Typography>
//                           </Box>
//                         </TableCell>
//                         <TableCell align="center">
//                           <Typography fontWeight="bold" color="primary">
//                             {request.requestedlimit}
//                           </Typography>
//                         </TableCell>
//                         <TableCell align="center">
//                           <Typography fontWeight="bold" color="success.main">
//                             {request.actualtransferredcount || 0}
//                           </Typography>
//                         </TableCell>
//                         <TableCell>
//                           <Chip 
//                             label={request.status} 
//                             color={getStatusColor(request.status)}
//                             size="small"
//                           />
//                         </TableCell>
//                         <TableCell>
//                           <Tooltip title={request.notes || 'No notes'}>
//                             <Typography variant="body2" sx={{ 
//                               maxWidth: 200, 
//                               overflow: 'hidden', 
//                               textOverflow: 'ellipsis',
//                               whiteSpace: 'nowrap'
//                             }}>
//                               {request.notes?.substring(0, 50) || '-'}
//                             </Typography>
//                           </Tooltip>
//                         </TableCell>
//                         <TableCell align="center">
//                           <Tooltip title="View Details">
//                             <IconButton 
//                               size="small" 
//                               onClick={() => {
//                                 setSelectedRequest(request);
//                                 setDetailsDialogOpen(true);
//                               }}
//                             >
//                               <VisibilityIcon fontSize="small" />
//                             </IconButton>
//                           </Tooltip>
//                         </TableCell>
//                       </TableRow>
//                     ))}
//                   </TableBody>
//                 </Table>
//               </TableContainer>
              
//               {/* Pagination Section */}
//               <Stack 
//                 direction={{ xs: 'column', sm: 'row' }} 
//                 justifyContent="space-between" 
//                 alignItems="center" 
//                 spacing={2}
//                 sx={{ mt: 3 }}
//               >
//                 {/* Items Per Page Selector */}
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                   <Typography variant="body2" color="text.secondary">
//                     Show:
//                   </Typography>
//                   <FormControl size="small" sx={{ minWidth: 80 }}>
//                     <Select
//                       value={limit}
//                       onChange={handleLimitChange}
//                       variant="outlined"
//                     >
//                       <MenuItem value={5}>5</MenuItem>
//                       <MenuItem value={10}>10</MenuItem>
//                       <MenuItem value={20}>20</MenuItem>
//                       <MenuItem value={50}>50</MenuItem>
//                       <MenuItem value={100}>100</MenuItem>
//                     </Select>
//                   </FormControl>
//                   <Typography variant="body2" color="text.secondary">
//                     entries
//                   </Typography>
//                 </Box>

//                 {/* Pagination Component */}
//                 {totalPages > 1 && (
//                   <Pagination
//                     count={totalPages}
//                     page={currentPage}
//                     onChange={handlePageChange}
//                     color="primary"
//                     showFirstButton
//                     showLastButton
//                     size="medium"
//                   />
//                 )}

//                 {/* Total Info */}
//                 <Typography variant="body2" color="text.secondary">
//                   Showing {startItem} to {endItem} of {totalItems} entries
//                 </Typography>
//               </Stack>
//             </>
//           ) : (
//             <Alert severity="info">
//               No requests found. No one has made any data requests yet.
//             </Alert>
//           )}
//         </DialogContent>

//         <DialogActions sx={{ p: 2.5, borderTop: '1px solid #e0e0e0' }}>
//           <Button onClick={onClose} variant="contained">
//             Close
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Details Dialog */}
//       <Dialog
//         open={detailsDialogOpen}
//         onClose={() => setDetailsDialogOpen(false)}
//         maxWidth="md"
//         fullWidth
//       >
//         <DialogTitle>Request Details</DialogTitle>
//         <DialogContent>
//           {selectedRequest && (
//             <Box sx={{ py: 2 }}>
//               <Grid container spacing={2}>
//                 <Grid item xs={12} md={6}>
//                   <Typography variant="subtitle2" color="primary" gutterBottom>
//                     Request Information:
//                   </Typography>
//                   <Typography variant="body2">• Request ID: {selectedRequest._id}</Typography>
//                   <Typography variant="body2">• Date: {formatDate(selectedRequest.createdAt)}</Typography>
//                   <Typography variant="body2">• Requested: {selectedRequest.requestedlimit} leads</Typography>
//                   <Typography variant="body2">• Transferred: {selectedRequest.actualtransferredcount || 0} leads</Typography>
//                   <Typography variant="body2">• Status: {selectedRequest.status}</Typography>
//                   <Typography variant="body2">• Max Allowed: {selectedRequest.maxallowedlimit || '-'}</Typography>
//                 </Grid>
//                 <Grid item xs={12} md={6}>
//                   <Typography variant="subtitle2" color="primary" gutterBottom>
//                     User Information:
//                   </Typography>
//                   <Typography variant="body2">• Name: {selectedRequest.userid?.name || '-'}</Typography>
//                   <Typography variant="body2">• Email: {selectedRequest.userid?.email || '-'}</Typography>
//                   <Typography variant="body2">• Role: {selectedRequest.userid?.role || '-'}</Typography>
//                   <Typography variant="body2">• User Limit: {selectedRequest.userid?.requestedleadslimit || '-'}</Typography>
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Typography variant="subtitle2" color="primary" gutterBottom>
//                     Notes:
//                   </Typography>
//                   <Typography variant="body2">{selectedRequest.notes || 'No notes'}</Typography>
//                 </Grid>
//                 {selectedRequest.leadsids && selectedRequest.leadsids.length > 0 && (
//                   <Grid item xs={12}>
//                     <Typography variant="subtitle2" color="primary" gutterBottom>
//                       Transferred Leads ({selectedRequest.leadsids.length}):
//                     </Typography>
//                     <TableContainer component={Paper} sx={{ maxHeight: 300 }}>
//                       <Table size="small" stickyHeader>
//                         <TableHead>
//                           <TableRow>
//                             <TableCell>#</TableCell>
//                             <TableCell>Name</TableCell>
//                             <TableCell>Phone</TableCell>
//                             <TableCell>Project</TableCell>
//                             <TableCell>Channel</TableCell>
//                           </TableRow>
//                         </TableHead>
//                         <TableBody>
//                           {selectedRequest.leadsids.map((lead, idx) => (
//                             <TableRow key={idx}>
//                               <TableCell>{idx + 1}</TableCell>
//                               <TableCell>{lead.name}</TableCell>
//                               <TableCell>{lead.phone}</TableCell>
//                               <TableCell>{lead.project?.name || '-'}</TableCell>
//                               <TableCell>{lead.chanel?.name || '-'}</TableCell>
//                             </TableRow>
//                           ))}
//                         </TableBody>
//                       </Table>
//                     </TableContainer>
//                   </Grid>
//                 )}
//               </Grid>
//             </Box>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setDetailsDialogOpen(false)} variant="outlined">
//             Close
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </>
//   );
// };










// after 13-7-2026

import React, { useState, useEffect, useCallback, memo } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  Drawer, Box, Typography, IconButton, Chip,
  CircularProgress, Tooltip, Pagination,
} from '@mui/material';
import { GetAll_Sales_Request_Data_Limit_Action } from '../../Redux/Actions/UsersAction';
import { Notify } from '../../Utility/Notify';
import * as XLSX from 'xlsx';

/* ── helpers ── */
const getInitials = (name = '') =>
  name.split(' ').filter(Boolean).map(w => w[0]).join('').toUpperCase().slice(0, 2) || '?';

const avatarColor = (name = '') => {
  const c = ['#3B82F6','#8B5CF6','#EC4899','#14B8A6','#F59E0B','#EF4444','#22C55E','#6366F1'];
  let h = 0;
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) % c.length;
  return c[h];
};

const fmtDate = (d) => {
  if (!d) return { date:'-', time:'' };
  const dt = new Date(d);
  return {
    date: dt.toLocaleDateString('en-GB',  { day:'2-digit', month:'2-digit', year:'numeric' }),
    time: dt.toLocaleTimeString('en-GB',  { hour:'2-digit', minute:'2-digit' }),
  };
};

const STATUS = {
  completed : { bg:'#DCFCE7', color:'#166534', dot:'#22C55E', label:'Completed' },
  pending   : { bg:'#FEF3C7', color:'#92400E', dot:'#F59E0B', label:'Pending'   },
  failed    : { bg:'#FEE2E2', color:'#991B1B', dot:'#EF4444', label:'Failed'    },
  partial   : { bg:'#DBEAFE', color:'#1E40AF', dot:'#3B82F6', label:'Partial'   },
};

/* ── token colors ── */
const C = {
  bg    : '#fff !important',
  bg2   : '#F8FAFC !important',
  bg3   : '#FAFBFD !important',
  border: '#F1F5F9',
  text  : '#0F172A',
    text2  : '#fff !important',

  muted : '#94A3B8',
  accent: '#1E3A8A',
};

/* ════════════════════════════════════════════════════════════════════
   ROW — memoized to prevent re-render
════════════════════════════════════════════════════════════════════ */
const Row = memo(({ req, onView }) => {
  const d  = fmtDate(req.createdAt);
  const st = STATUS[req.status] || STATUS.pending;
  const bg = avatarColor(req.userid?.name || '?');

  return (
    <tr style={{ borderBottom:`1px solid ${C.border}` }}>
      {/* date */}
      <td style={{ padding:'12px 14px', whiteSpace:'nowrap' }}>
        <div style={{ fontSize:13, fontWeight:600, color:C.text }}>{d.date}</div>
        <div style={{ fontSize:11, color:C.muted, marginTop:2 }}>{d.time}</div>
      </td>

      {/* user */}
      <td style={{ padding:'12px 14px' }}>
        <div style={{ display:'flex', alignItems:'center', gap:10 }}>
          <div style={{ width:30, height:30, borderRadius:'50%', background:bg, display:'flex', alignItems:'center', justifyContent:'center', fontSize:11, fontWeight:700, color:'#fff', flexShrink:0 }}>
            {getInitials(req.userid?.name || '?')}
          </div>
          <div>
            <div style={{ fontSize:13, fontWeight:600, color:C.text }}>{req.userid?.name || '-'}</div>
            <div style={{ fontSize:11, color:C.muted }}>{req.userid?.email || '-'}</div>
            <div style={{ fontSize:10, fontWeight:700, color:'#3B82F6', textTransform:'uppercase', marginTop:2 }}>
              {req.userid?.role || '-'}
            </div>
          </div>
        </div>
      </td>

      {/* sales */}
      <td style={{ padding:'12px 14px' }}>
        <div style={{ fontSize:13, fontWeight:600, color:C.text}}>{req.salesid?.name || '-'}</div>
        <div style={{ fontSize:11, color:C.muted }}>{req.salesid?.userlog?.email || '-'}</div>
      </td>

      {/* requested */}
      <td style={{ padding:'12px 14px', textAlign:'center' }}>
        <span style={{ fontSize:15, fontWeight:700, color:C.accent }}>{req.requestedlimit}</span>
      </td>

      {/* transferred */}
      <td style={{ padding:'12px 14px', textAlign:'center' }}>
        <span style={{ fontSize:15, fontWeight:700, color:'#16A34A' }}>{req.actualtransferredcount || 0}</span>
      </td>

      {/* status */}
      <td style={{ padding:'12px 14px' }}>
        <span style={{ display:'inline-flex', alignItems:'center', gap:5, padding:'4px 10px', borderRadius:20, background:st.bg, color:st.color, fontSize:11, fontWeight:700, textTransform:'uppercase' }}>
          <span style={{ width:6, height:6, borderRadius:'50%', background:st.dot, flexShrink:0 }} />
          {st.label}
        </span>
      </td>

      {/* notes */}
      <td style={{ padding:'12px 14px' }}>
        <Tooltip title={req.notes || ''}>
          <span style={{ fontSize:12, color:'#64748B', display:'block', maxWidth:180, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
            {req.notes?.substring(0, 45) || '-'}
          </span>
        </Tooltip>
      </td>

      {/* action */}
      <td style={{ padding:'12px 14px', textAlign:'center' }}>
        <IconButton size="small" onClick={() => onView(req)}
          sx={{ border:'1.5px solid #E2E8F0', borderRadius:'6px', width:28, height:28, color:'#64748B', '&:hover':{ background:'#F1F5F9', color:C.text } }}>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
        </IconButton>
      </td>
    </tr>
  );
});

/* ════════════════════════════════════════════════════════════════════
   MAIN
════════════════════════════════════════════════════════════════════ */
export const Admin_Report_Model_For_Requested_Data = ({ open, onClose }) => {
  const dispatch = useDispatch();

  const [page,            setPage]            = useState(1);
  const [limit,           setLimit]           = useState(10);
  const [statusFilter,    setStatusFilter]    = useState('');
  const [fromDate,        setFromDate]        = useState('');
  const [toDate,          setToDate]          = useState('');
  const [searchUser,      setSearchUser]      = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const [loading,         setLoading]         = useState(true);
  const [selected,        setSelected]        = useState(null);
  const [detailOpen,      setDetailOpen]      = useState(false);

  const historyData    = useSelector(s => s.Allusers?.GetAll_SalesRequestData?.data?.data
    || s.Allusers?.GetAll_SalesRequestData?.data || [], shallowEqual);
  const paginationData = useSelector(s => s.Allusers?.GetAll_SalesRequestData?.pagination
    || null, shallowEqual);

  const currentPage = paginationData?.currentPage || 1;
  const totalPages  = paginationData?.totalPages  || 1;
  const totalItems  = paginationData?.totalItems  || 0;
  const startItem   = totalItems === 0 ? 0 : (currentPage - 1) * limit + 1;
  const endItem     = Math.min(currentPage * limit, totalItems);

  /* debounce */
  useEffect(() => {
    const t = setTimeout(() => { setDebouncedSearch(searchUser); setPage(1); }, 500);
    return () => clearTimeout(t);
  }, [searchUser]);

  const fetchHistory = useCallback(async () => {
    setLoading(true);
    try {
      const q = new URLSearchParams({ page, limit, sortBy:'createdAt', sortOrder:'desc', populate:'true' });
      if (statusFilter)    q.append('status',   statusFilter);
      if (fromDate)        q.append('fromDate',  fromDate);
      if (toDate)          q.append('toDate',    toDate);
      if (debouncedSearch) q.append('userId',    debouncedSearch);
      await dispatch(GetAll_Sales_Request_Data_Limit_Action(q.toString()));
    } catch {
      Notify('error', 'Failed to load request history', '');
    } finally {
      setLoading(false);
    }
  }, [page, limit, statusFilter, fromDate, toDate, debouncedSearch, dispatch]);

  useEffect(() => { if (open) fetchHistory(); }, [open, fetchHistory]);

  const handleReset = () => {
    setStatusFilter(''); setFromDate(''); setToDate('');
    setSearchUser(''); setDebouncedSearch(''); setPage(1);
  };

  const exportToExcel = () => {
    if (!historyData.length) return;
    const rows = historyData.map(r => ({
      'Date': `${fmtDate(r.createdAt).date} ${fmtDate(r.createdAt).time}`,
      'User Name': r.userid?.name || '-', 'Email': r.userid?.email || '-',
      'Role': r.userid?.role || '-', 'Sales': r.salesid?.name || '-',
      'Requested': r.requestedlimit, 'Transferred': r.actualtransferredcount || 0,
      'Status': r.status, 'Notes': r.notes || '-',
    }));
    const ws = XLSX.utils.json_to_sheet(rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Report');
    XLSX.writeFile(wb, `requested-data-${Date.now()}.xlsx`);
  };

  /* ── shared input style ── */
  const inp = {
    padding:'7px 11px', border:'1.5px solid #E2E8F0', borderRadius:8,
    fontFamily:'inherit', fontSize:13, color:C.text, background:C.bg,
    outline:'none', transition:'border-color 0.15s',
  };

  const TH = ({ children, center }) => (
    <th style={{ padding:'9px 14px', textAlign: center ? 'center' : 'left', fontSize:10.5, fontWeight:700, letterSpacing:'0.08em', color:C.muted, textTransform:'uppercase', whiteSpace:'nowrap', background:C.bg2, borderBottom:`1.5px solid #E2E8F0` }}>
      {children}
    </th>
  );

  return (
    <>
      {/* ── Main Drawer ── */}
      <Drawer
        anchor="right"
        open={open}
        onClose={onClose}
        PaperProps={{
          sx: {
            width: { xs:'100vw', sm:'95vw', md:'95vw', lg:'78vw' },
            maxWidth: 1220,
            display:'flex', flexDirection:'column',
            fontFamily:"'DM Sans', sans-serif",
            overflow:'hidden',
            background:'#fff !important'
          }
        }}
        SlideProps={{ timeout: 280 }}
      >
        {/* Header */}
        <Box sx={{ px:3.5, py:2.5, borderBottom:`1px solid ${C.border}`, display:'flex', alignItems:'center', justifyContent:'space-between', flexShrink:0, background:C.bg }}>
          <Typography sx={{ fontSize:20, fontWeight:700, color:C.text, letterSpacing:'-0.3px', fontFamily:'inherit' }}>
            Requested Data History
          </Typography>
          <Box sx={{ display:'flex', gap:1.2, alignItems:'center' }}>
            <button onClick={handleReset} style={{ display:'flex', alignItems:'center', gap:6, padding:'7px 14px', borderRadius:8, border:'1.5px solid #E2E8F0', background:C.bg, fontFamily:'inherit', fontSize:13, fontWeight:600, color:'#64748B', cursor:'pointer' }}>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/></svg>
              Reset Filters
            </button>
            <button onClick={exportToExcel} style={{ display:'flex', alignItems:'center', gap:6, padding:'7px 16px', borderRadius:8, border:'none', background:C.accent, color:'#fff', fontFamily:'inherit', fontSize:13, fontWeight:700, cursor:'pointer' }}>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
              Export to Excel
            </button>
            <IconButton size="small" onClick={onClose} sx={{ border:'1.5px solid #E2E8F0', borderRadius:'8px', width:32, height:32, color:'#64748B', '&:hover':{ background:'#F1F5F9' } }}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </IconButton>
          </Box>
        </Box>

        {/* Filters */}
        <Box sx={{ px:3.5, py:2, borderBottom:`1px solid ${C.border}`, display:'flex', gap:1.5, alignItems:'flex-end', flexWrap:'wrap', flexShrink:0, background:C.bg3 }}>
          {/* status */}
          <Box sx={{ display:'flex', flexDirection:'column', gap:'4px' }}>
            <span style={{ fontSize:10, fontWeight:700, letterSpacing:'0.08em', color:C.muted, textTransform:'uppercase' }}>Status</span>
            <select style={{ ...inp, minWidth:150 }} value={statusFilter} onChange={e => { setStatusFilter(e.target.value); setPage(1); }}>
              <option value="">All Statuses</option>
              <option value="completed">Completed</option>
              <option value="pending">Pending</option>
              <option value="failed">Failed</option>
              <option value="partial">Partial</option>
            </select>
          </Box>

          {/* user search */}
          <Box sx={{ display:'flex', flexDirection:'column', gap:'4px' }}>
            <span style={{ fontSize:10, fontWeight:700, letterSpacing:'0.08em', color:C.muted, textTransform:'uppercase' }}>User</span>
            <div style={{ position:'relative', display:'flex', alignItems:'center' }}>
              <span style={{ position:'absolute', left:10, color:C.muted, pointerEvents:'none' }}>
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
              </span>
              <input style={{ ...inp, paddingLeft:32, minWidth:190 }} placeholder="Search user..." value={searchUser} onChange={e => setSearchUser(e.target.value)} />
            </div>
          </Box>

          {/* date range */}
          <Box sx={{ display:'flex', flexDirection:'column', gap:'4px' }}>
            <span style={{ fontSize:10, fontWeight:700, letterSpacing:'0.08em', color:C.muted, textTransform:'uppercase' }}>Date Range</span>
            <div style={{ display:'flex', alignItems:'center', gap:8 }}>
              <input type="date" style={{ ...inp, minWidth:130 }} value={fromDate} onChange={e => { setFromDate(e.target.value); setPage(1); }} />
              <span style={{ fontSize:13, color:C.muted, fontWeight:500 }}>to</span>
              <input type="date" style={{ ...inp, minWidth:130 }} value={toDate}   onChange={e => { setToDate(e.target.value);   setPage(1); }} />
            </div>
          </Box>
        </Box>

        {/* Table area */}
        <Box sx={{ flex:1, overflowY:'auto', px:3.5, pb:2, '&::-webkit-scrollbar':{ width:'5px' }, '&::-webkit-scrollbar-thumb':{ background:'#CBD5E1', borderRadius:'4px' } }}>
          {loading ? (
            <Box sx={{ display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', py:10, gap:2, color:C.muted }}>
              <CircularProgress size={30} sx={{ color:C.accent }} />
              <Typography sx={{ fontSize:13, fontFamily:'inherit', color:C.muted }}>Loading…</Typography>
            </Box>
          ) : !historyData.length ? (
            <Box sx={{ display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', py:10, gap:1.5, color:C.muted }}>
              <span style={{ fontSize:36 }}>📭</span>
              <Typography sx={{ fontSize:14, fontFamily:'inherit' }}>No requests found.</Typography>
            </Box>
          ) : (
            <Box sx={{ overflowX:'auto', mt:2 }}>
              <table style={{ width:'100%', borderCollapse:'collapse', background:C.bg, borderRadius:12, overflow:'hidden', border:`1.5px solid #E2E8F0` }}>
                <thead>
                  <tr>
                    <TH>Date</TH>
                    <TH>User Info</TH>
                    <TH>Sales Info</TH>
                    <TH center>Requested</TH>
                    <TH center>Transferred</TH>
                    <TH>Status</TH>
                    <TH>Notes</TH>
                    <TH center>Actions</TH>
                  </tr>
                </thead>
                <tbody>
                  {historyData.map(req => (
                    <Row key={req._id} req={req} onView={r => { setSelected(r); setDetailOpen(true); }} />
                  ))}
                </tbody>
              </table>
            </Box>
          )}
        </Box>

        {/* Footer */}
        <Box sx={{ px:3.5, py:1.8, borderTop:`1px solid ${C.border}`, display:'flex', alignItems:'center', justifyContent:'space-between', flexShrink:0, background:C.bg, flexWrap:'wrap', gap:2 }}>
          <Box sx={{ display:'flex', alignItems:'center', gap:1, fontSize:13, color:'#64748B', fontFamily:'inherit' }}>
            Show:
            <select style={{ padding:'4px 8px', border:'1.5px solid #E2E8F0', borderRadius:6, fontFamily:'inherit', fontSize:13, color:C.text, background:C.bg, outline:'none', width:70 }}
              value={limit} onChange={e => { setLimit(Number(e.target.value)); setPage(1); }}>
              {[5,10,20,50,100].map(n => <option key={n} value={n}>{n}</option>)}
            </select>
            entries
          </Box>

          {totalPages > 1 && (
            <Pagination
              count={totalPages} page={currentPage}
              onChange={(_, p) => setPage(p)}
              color="primary" size="small"
              showFirstButton showLastButton
              sx={{ '& .MuiPaginationItem-root':{ fontFamily:'inherit', fontSize:13 } }}
            />
          )}

          <Typography sx={{ fontSize:13, color:'#64748B', fontFamily:'inherit' }}>
            Showing {startItem} to {endItem} of {totalItems} entries
          </Typography>
        </Box>
      </Drawer>

      {/* ── Detail Drawer ── */}
      <Drawer
        anchor="right"
        open={detailOpen}
        onClose={() => setDetailOpen(false)}
        PaperProps={{ sx: { width:{ xs:'100vw', sm:520 }, fontFamily:"'DM Sans',sans-serif", display:'flex', flexDirection:'column' } }}
        SlideProps={{ timeout: 220 }}

      >
        {selected && (
          <>
            <Box sx={{ px:3, py:2.5, borderBottom:`1px solid ${C.border}`, display:'flex', alignItems:'center', justifyContent:'space-between', flexShrink:0 }}>
              <Typography sx={{ fontSize:16, fontWeight:700, color:C.text2, fontFamily:'inherit' }}>Request Details</Typography>
              <IconButton size="small" onClick={() => setDetailOpen(false)} sx={{ border:'1.5px solid #E2E8F0', borderRadius:'8px', width:30, height:30, color:'#64748B' }}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              </IconButton>
            </Box>

            <Box sx={{ flex:1, overflowY:'auto', px:3, py:2.5 }}>
              {/* Request info */}
              <Typography sx={{ fontSize:10, fontWeight:700, letterSpacing:'0.1em', color:C.muted, textTransform:'uppercase', mb:1.5 }}>Request Information</Typography>
              <Box sx={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'10px 20px', mb:3 }}>
                {[['Request ID', selected._id],['Date', `${fmtDate(selected.createdAt).date} ${fmtDate(selected.createdAt).time}`],['Requested', `${selected.requestedlimit} leads`],['Transferred', `${selected.actualtransferredcount||0} leads`],['Status', selected.status],['Max Allowed', selected.maxallowedlimit||'-']].map(([l,v]) => (
                  <Box key={l}><div style={{ fontSize:11, color:C.muted, fontWeight:600 }}>{l}</div><div style={{ fontSize:13, color:C.text2, fontWeight:500, marginTop:2 }}>{v}</div></Box>
                ))}
              </Box>

              {/* User info */}
              <Typography sx={{ fontSize:10, fontWeight:700, letterSpacing:'0.1em', color:C.muted, textTransform:'uppercase', mb:1.5 }}>User Information</Typography>
              <Box sx={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'10px 20px', mb:3 }}>
                {[['Name', selected.userid?.name||'-'],['Email', selected.userid?.email||'-'],['Role', selected.userid?.role||'-'],['User Limit', selected.userid?.requestedleadslimit||'-']].map(([l,v]) => (
                  <Box key={l}><div style={{ fontSize:11, color:C.muted, fontWeight:600 }}>{l}</div><div style={{ fontSize:13, color:C.text2, fontWeight:500, marginTop:2 }}>{v}</div></Box>
                ))}
              </Box>

              {/* Notes */}
              {selected.notes && (
                <>
                  <Typography sx={{ fontSize:10, fontWeight:700, letterSpacing:'0.1em', color:C.muted, textTransform:'uppercase', mb:1 }}>Notes</Typography>
                  <Typography sx={{ fontSize:13, color:'#475569', lineHeight:1.6, mb:3, fontFamily:'inherit' }}>{selected.notes}</Typography>
                </>
              )}

              {/* Leads table */}
              {selected.leadsids?.length > 0 && (
                <>
                  <Typography sx={{ fontSize:10, fontWeight:700, letterSpacing:'0.1em', color:C.text2 , textTransform:'uppercase', mb:1.5 }}>
                    Transferred Leads ({selected.leadsids.length})
                  </Typography>
                  <Box sx={{ overflowX:'auto' }}>
                    <table style={{ width:'100%', borderCollapse:'collapse', border:`1.5px solid #E2E8F0`, borderRadius:10, overflow:'hidden' }}>
                      <thead>
                        <tr style={{ background:C.bg2, borderBottom:`1.5px solid #E2E8F0` }}>
                          {['#','Name','Phone','Project','Channel'].map(h => (
                            <th key={h} style={{ padding:'8px 12px', textAlign:'left', fontSize:10, fontWeight:700, letterSpacing:'0.08em', color:C.muted, textTransform:'uppercase' }}>{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {selected.leadsids.map((lead, i) => (
                          <tr key={i} style={{ borderBottom:`1px solid ${C.border}` }}>
                            <td style={{ padding:'10px 12px', fontSize:12, color:C.muted }}>{i+1}</td>
                            <td style={{ padding:'10px 12px', fontSize:13, fontWeight:600, color:C.text2 }}>{lead.name}</td>
                            <td style={{ padding:'10px 12px', fontSize:13, color:C.text2 }}>{lead.phone}</td>
                            <td style={{ padding:'10px 12px', fontSize:13, color:C.text2 }}>{lead.project?.name||'-'}</td>
                            <td style={{ padding:'10px 12px', fontSize:13, color:C.text2 }}>{lead.chanel?.name||'-'}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </Box>
                </>
              )}
            </Box>

            <Box sx={{ px:3, py:2, borderTop:`1px solid ${C.border}`, display:'flex', justifyContent:'flex-end', flexShrink:0 }}>
              <button onClick={() => setDetailOpen(false)} style={{ padding:'8px 22px', borderRadius:8, border:'none', background:C.text, color:'#fff', fontFamily:'inherit', fontSize:13, fontWeight:700, cursor:'pointer' }}>
                Close
              </button>
            </Box>
          </>
        )}
      </Drawer>
    </>
  );
};





